import React, { memo } from 'react';
import { View } from 'react-native';
export default /*#__PURE__*/memo(_ref => {
  let {
    children
  } = _ref;
  return /*#__PURE__*/React.createElement(View, {
    testID: "crt-full-app-footer-section"
  }, children);
});
//# sourceMappingURL=FooterSection.js.map